import Home from "./pages/home/index";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { HashRouter, Route, Routes } from "react-router-dom";
import Header from "./components/header/index";
import Footer from "./components/footer/index";
import Privacy from "./pages/privacypolicy/index";
import Register from "./pages/home/registeration";
import Contactus from "./pages/contactus/index";
import Termsandcondition from "./pages/terms&condition/index";
import Aboutus from "./pages/aboutus/index";
import OurProducts from "./pages/ourproducts/index";
import NotFound404 from "./pages/NotFound404";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="*" element={<NotFound404 />} />
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/ourproducts" element={<OurProducts />} />
        <Route path="/terms&condition" element={<Termsandcondition />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
